module.exports = __webpack_public_path__ + "static/media/ico_btn_union.2631eadd.svg";